export default {"src":"/_next/static/media/add_to_cart_with_white_background.c6b5d803.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};